/**
 * ╔══════════════════════════════════════════════════════════════════╗
 * ║  HERCULES — Featured Collection JS                              ║
 * ║  Dosya: assets/hercules-featured-collection.js                  ║
 * ║                                                                  ║
 * ║  Görevler:                                                       ║
 * ║  1. Scroll reveal (IntersectionObserver)                        ║
 * ║  2. Schema renklerini CSS değişkenine aktarma                   ║
 * ║  3. Layout ayarlarını uygulama (swap, padding, min-height)      ║
 * ║  4. Shopify Theme Editor live reload desteği                    ║
 * ╚══════════════════════════════════════════════════════════════════╝
 */

(function () {
  "use strict";

  /* ─── Sabitler ─────────────────────────────────────────────────── */
  const SELECTOR_SECTION = ".hfc-section";
  const SELECTOR_WRAPPER = ".hfc-wrapper";
  const CLASS_REVEAL = "hfc-reveal";
  const CLASS_VISIBLE = "hfc-reveal--visible";
  const CLASS_DISABLED = "hfc-reveal--disabled";
  const CLASS_SWAPPED = "hfc-section--swapped";
  const OBSERVER_THRESHOLD = 0.12;

  /* ─── Yardımcı: data attribute okuma ───────────────────────────── */
  function attr(el, key, fallback) {
    var val = el.getAttribute("data-hfc-" + key);
    return val !== null ? val : fallback;
  }

  /* ─── Renkleri CSS değişkeni olarak uygula ──────────────────────── */
  function applyColors(section) {
    var accent = attr(section, "accent", null);
    var text = attr(section, "text", null);
    var btnText = attr(section, "btn-text", null);

    if (accent) section.style.setProperty("--hfc-section-accent", accent);
    if (text) section.style.setProperty("--hfc-section-text", text);
    if (btnText) section.style.setProperty("--hfc-section-btn-text", btnText);
  }

  /* ─── Padding & min-height uygula ──────────────────────────────── */
  function applyLayout(wrapper, section) {
    var paddingTop = attr(wrapper, "padding-top", null);
    var paddingBottom = attr(wrapper, "padding-bottom", null);
    var minHeight = attr(section, "min-height", null);

    if (paddingTop) wrapper.style.paddingTop = paddingTop + "px";
    if (paddingBottom) wrapper.style.paddingBottom = paddingBottom + "px";
    if (minHeight) section.style.minHeight = minHeight + "px";
  }

  /* ─── Swap layout ───────────────────────────────────────────────── */
  function applySwap(section) {
    var swapped = attr(section, "swap", "false");
    if (swapped === "true") {
      section.classList.add(CLASS_SWAPPED);
    } else {
      section.classList.remove(CLASS_SWAPPED);
    }
  }

  /* ─── Scroll reveal kurulumu ────────────────────────────────────── */
  function setupReveal(section) {
    var enabled = attr(section, "reveal", "true");

    /* Reveal devre dışıysa veya reduced-motion aktifse direkt göster */
    if (
      enabled === "false" ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      section.classList.remove(CLASS_REVEAL);
      section.classList.add(CLASS_DISABLED);
      return;
    }

    /* IntersectionObserver ile ekrana girince tetikle */
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add(CLASS_VISIBLE);
              observer.unobserve(entry.target); /* Bir kez tetikle */
            }
          });
        },
        { threshold: OBSERVER_THRESHOLD },
      );
      observer.observe(section);
    } else {
      /* Eski tarayıcı fallback */
      section.classList.add(CLASS_VISIBLE);
    }
  }

  /* ─── Tek bir section'ı başlat ─────────────────────────────────── */
  function initSection(section) {
    var wrapper = section.closest(SELECTOR_WRAPPER) || section.parentElement;

    applyColors(section);
    applyLayout(wrapper, section);
    applySwap(section);
    setupReveal(section);
  }

  /* ─── Tüm section'ları başlat ──────────────────────────────────── */
  function init() {
    var sections = document.querySelectorAll(SELECTOR_SECTION);
    sections.forEach(initSection);
  }

  /* ─── Shopify Theme Editor desteği ─────────────────────────────── */
  /*
   * Tema editöründe schema ayarları değiştiğinde Shopify iki event
   * gönderir: shopify:section:load ve shopify:section:select.
   * Biz her ikisinde de ilgili section'ı yeniden başlatıyoruz.
   */
  document.addEventListener("shopify:section:load", function (event) {
    var container = event.target;
    if (!container) return;

    var section = container.querySelector(SELECTOR_SECTION);
    if (section) {
      /* Reveal state'ini sıfırla ki yeniden animate etsin */
      section.classList.remove(CLASS_VISIBLE, CLASS_DISABLED);
      initSection(section);
    }
  });

  document.addEventListener("shopify:section:select", function (event) {
    var container = event.target;
    if (!container) return;

    var section = container.querySelector(SELECTOR_SECTION);
    if (section) {
      /* Editörde seçilince direkt göster */
      section.classList.add(CLASS_VISIBLE);
    }
  });

  document.addEventListener("shopify:section:deselect", function (event) {
    var container = event.target;
    if (!container) return;

    var section = container.querySelector(SELECTOR_SECTION);
    if (section) {
      /* Deselect'te reveal reset */
      section.classList.remove(CLASS_VISIBLE);
    }
  });

  /* ─── DOM hazır olunca çalıştır ─────────────────────────────────── */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
